import React from 'react';



function Feature() {
  return (
    <div>
       <div className='bg-[#FFF] p-11'>
        <h1 className='flex justify-center item-center text-xl lg:text-4xl md:text-3xl font-bold mb-4'>We've been featured in</h1>
    <div className='grid  grid-cols-2 md:grid-cols-3 lg:grid-cols-6 xs:gap-24 lg:gap-3 justify-center content-center items-center p-4'>
      <div className='bg-[#FF9CA0] relative border border-r-2 border-l-2 border-b-2 border-t-1 border-black rounded-xl h-20 w-[140px] '>
      <div className='bg-[#FFF]  absolute right-[2px] bottom-[1.5px] border border-2 border-black rounded-xl h-20 w-[140px]   '>
        </div>
      </div>
      <div className='bg-[#D5B0FF] relative border border-r-2 border-l-2 border-b-2 border-t-1 border-black rounded-xl h-20 w-[140px] '>
      <div className='bg-[#FFF]  absolute right-[2px] bottom-[1.5px] border border-2 border-black rounded-xl h-20 w-[140px]   '>
        </div>
      </div>
      <div className='bg-[#FFC8B0] relative border border-r-2 border-l-2 border-b-2 border-t-1 border-black rounded-xl h-20 w-[140px] '>
      <div className='bg-[#FFF]  absolute right-[2px] bottom-[1.5px] border border-2 border-black rounded-xl h-20 w-[140px]   '>
        </div>
      </div>
      <div className='bg-[#9AE1FF] relative border border-r-2 border-l-2 border-b-2 border-t-1 border-black rounded-xl h-20 w-[140px] '>
      <div className='bg-[#FFF]  absolute right-[2px] bottom-[1.5px] border border-2 border-black rounded-xl h-20 w-[140px]   '>
        </div>
      </div>
      <div className='bg-[#FF9498] relative border border-r-2 border-l-2 border-b-2 border-t-1 border-black rounded-xl h-20 w-[140px] '>
      <div className='bg-[#FFF]  absolute right-[2px] bottom-[1.5px] border border-2 border-black rounded-xl h-20 w-[140px]   '>
        </div>
      </div>
      <div className='bg-[#FFCCD4] relative border border-r-2 border-l-2 border-b-2 border-t-1 border-black rounded-xl h-20 w-[140px] '>
      <div className='bg-[#FFF]  absolute right-[2px] bottom-[1.5px] border border-2 border-black rounded-xl h-20 w-[140px]   '>
        </div>
      </div>
      
      
      
    </div>
    </div>
    </div>
  );
}

export default Feature;
